import Immutable from 'seamless-immutable';
import _ from 'lodash';

const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
const SEND_REQUEST = 'SEND_REQUEST';
const UPDATE_LIST = 'UPDATE_LIST';
const SEND_REQUEST_REFRESH_ITEM = 'SEND_REQUEST_REFRESH_ITEM';
const REFRESH_ITEM = 'REFRESH_ITEM';
const ADD_ITEM_TO_UP = 'ADD_ITEM_TO_UP';
const ADD_ITEM_TO_DOWN = 'ADD_ITEM_TO_DOWN';
const REMOVE_ITEM = 'REMOVE_ITEM';
const INIT_STATE = 'INIT_STATE';

const reducerName = `list`;
const createReducerDotPathName = combineName => `${combineName}.${reducerName}`;

const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;
export const getState = (state, combineName) =>
  _.get(state, createReducerDotPathName(combineName));

const createListReducer = parentName => {
  function stateDefault() {
    return {
      mergeItemsMode: false,
      pathParams: {},
      queryParams: {},
      itemsById: {},
      itemsIds: []
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, SET_QUERY_PARAMS):
        return state.merge({ queryParams: action.payload });
      case createActionName(parentName, SEND_REQUEST):
        return state;
      case createActionName(parentName, UPDATE_LIST):
        if (state.mergeItemsMode) {
          return state.merge({
            itemsById: { ...state.itemsById, ...action.payload }
          });
        }
        return state.merge({
          itemsById: action.payload.itemsById,
          itemsIds: action.payload.itemsIds
        });
      case createActionName(parentName, SEND_REQUEST_REFRESH_ITEM):
        return state;
      case createActionName(parentName, REFRESH_ITEM):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          }
        });
      case createActionName(parentName, ADD_ITEM_TO_UP):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          itemsIds: [...[action.payload.itemId], ...state.itemsIds]
        });
      case createActionName(parentName, ADD_ITEM_TO_DOWN):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          itemsIds: [...state.itemsIds, ...[action.payload.itemId]]
        });
      case createActionName(parentName, REMOVE_ITEM): {
        const clone = Immutable.asMutable(state, { deep: true });
        const id = clone.itemsIds.indexOf(action.payload);
        if (id !== -1) clone.itemsIds.splice(id, 1);
        delete clone.itemsById[action.payload];
        return state.merge({
          itemsById: clone.itemsById,
          itemsIds: clone.itemsIds
        });
      }
      case createActionName(parentName, INIT_STATE):
        return Immutable({
          ...stateDefault(),
          ...{ mergeItemsMode: action.payload === true }
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createListReducer(parentName);
  return reduceObject;
}

// ACTIONS CREATOR
export const setQueryParams = (parentName, payload) => ({
  type: createActionName(parentName, SET_QUERY_PARAMS),
  payload
});
export const sendRequest = parentName => ({
  type: createActionName(parentName, SEND_REQUEST)
});
export const updateList = (parentName, payload) => ({
  type: createActionName(parentName, UPDATE_LIST),
  payload
});
export const sendRequestRefreshItem = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST_REFRESH_ITEM),
  payload
});
export const refreshItem = (parentName, payload) => ({
  type: createActionName(parentName, REFRESH_ITEM),
  payload
});
export const addItemToUp = (parentName, payload) => ({
  type: createActionName(parentName, ADD_ITEM_TO_UP),
  payload
});
export const addItemToDown = (parentName, payload) => ({
  type: createActionName(parentName, ADD_ITEM_TO_DOWN),
  payload
});
export const removeItem = (parentName, payload) => ({
  type: createActionName(parentName, REMOVE_ITEM),
  payload
});
export const initState = (parentName, payload) => ({
  type: createActionName(parentName, INIT_STATE),
  payload
});

// SELECTORS
export const selectQueryParams = (state, parentName) =>
  getState(state, parentName).queryParams;
export const selectItemsIds = (state, parentName) =>
  getState(state, parentName).itemsIds;
export const selectItemById = (state, parentName, itemId) =>
  getState(state, parentName).itemsById[itemId];



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/_list/reducer.js